
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Star } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

export interface ReviewItemProps {
  author: string;
  avatar?: string;
  rating: number;
  date: Date;
  content: string;
}

export const ReviewItem = ({ author, avatar, rating, date, content }: ReviewItemProps) => {
  return (
    <div className="border-b pb-4 mb-4 last:border-0">
      <div className="flex items-start gap-3 mb-2">
        <Avatar className="h-10 w-10">
          <AvatarImage src={avatar} alt={author} />
          <AvatarFallback>{author[0]}</AvatarFallback>
        </Avatar>
        <div className="flex-1">
          <div className="flex justify-between items-center mb-1">
            <h4 className="font-medium">{author}</h4>
            <span className="text-sm text-muted-foreground">
              {formatDistanceToNow(date, { addSuffix: true })}
            </span>
          </div>
          <div className="flex items-center mb-2">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star
                key={i}
                className={`h-4 w-4 ${
                  i < rating ? "text-amber-500 fill-amber-500" : "text-muted-foreground"
                }`}
              />
            ))}
          </div>
          <p className="text-muted-foreground">{content}</p>
        </div>
      </div>
    </div>
  );
};
